module.exports = __webpack_public_path__ + "img/onboard.2c87e5c4.png";